import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'
import MealForm from './mealForm';
import Breakfast from './breakfastForm'
import FullCalendar from './mealCalendar';
import BreakfastCalender from './breakfastCalender'
import NotificationSystem from 'react-notification-system';
import {get, postWithHeadersResponse} from "../../../server/actions";
import {MealTypes, MenuOrderTypes} from '../../../server/constants'
import {getGradeNamesByNumbers, getSchoolGrades, groupBy,
    getModuleEnum, getAccessLevelByModule, 
    gradeNoToText, formatDate, _addNotificationError, _addNotification, isWeekMenu, isRegularLunchOrderType} from '../../../server/util';
import {URL_VERSION} from '../../../server/constants';
import MenuOptions from '../../Misc/MenuOptions/menuOptions';
import {getMenuOptions} from '../../Misc/MenuOptions/menuOptionsActions';
import {BeatLoader} from 'react-spinners';
import moment from 'moment';
import Modal from 'react-modal'
import CutoffDays from './cutoffDays';
let meals = [];
let breakfastData=[];
let schoolGrades = '';
let grades = '';
let date = {};
const margin = {
    marginBottom: '0px !important'
};
const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '50%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};

const modEnum=getModuleEnum();
let gradeList=[];
class mealCreate extends Component {
    componentWillMount = () => {
        this.initData();        
    }
    initData=()=>{
        
        this.setState({
           // schoolGrades: this.props.schoolGrades,
            mealType:(this.props.lType||'')==''?(getMenuOptions()[0]||''):this.props.lType });
        if(this.menuId==0){
            this.setState({isEdit:false});
        }else{
            this.setState({isEdit:true,mealType:this.props.lType},()=>{
                if(this.state.mealType===MealTypes.LUNCH ||
                    this.state.mealType===MealTypes.SNACK){
                    this.getMealDatabyId(this.menuId);
                }
                else{
                    this.getBreakfastDataById(this.menuId);
                }
            });
        }

    }

    constructor(props) {
        super(props);
        this.state = {
            fireRedirect: false,
            schoolGrades: [],
            mealOrderedGrades:[],
            mealData:{},
            isEdit:false,
            finalGradesArray:[],
            mealType:(getMenuOptions()[0]||''),
            loading:false,
            alacarteDates:{start:moment().startOf('week'),end:moment().endOf('week')},
            cutOffObj:{cutOffDateTime: ''}
        }
        this.menuId=this.props.menuId||0;
        this.loadMeals = this.loadMeals.bind(this)
        this.back = this.back.bind(this);
        this.getMealDatabyId=this.getMealDatabyId.bind(this);
        this.getBreakfastDataById=this.getBreakfastDataById.bind(this);
        this.getMealCreatedGradsByMonth=this.getMealCreatedGradsByMonth.bind(this);
        this.mealGradeSelectionChange=this.mealGradeSelectionChange.bind(this);
        this.handleCreate=this.handleCreate.bind(this);
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }
    getMealDatabyId(id){
        this.setState({loading:true})
        get('/mealCalendarSummaries/' + this.menuId +'?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            if(data){
            let mealObj=data;
            mealObj.mealSummaryId=this.menuId;
            mealObj.isDiscountApplyed= ((data).itemPriceDisForMonthlyOrder||0)>0?true:false,
            mealObj.itemPriceDisForMonthlyOrder=data.itemPriceDisForMonthlyOrder||0;
            this.setState({mealData:mealObj,loading:false});
            this.getMealCreatedGradsByMonth(data.yearMonth);
            }else{
                this.setState({loading:false});
            }
        })
        .catch(
            (error) => {
                this.setState({loading:false})
                console.log('Get orderlist response', error)
            }
        )
    }
    getBreakfastDataById=(id)=>{
        get('/mealCalendarSummaries/' + this.menuId +'?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            if(data){
            let mealObj=data;
            mealObj.mealSummaryId=this.menuId;
            mealObj.isDiscountApplyed= ((data).itemPriceDisForMonthlyOrder||0)>0?true:false,
            mealObj.itemPriceDisForMonthlyOrder=data.itemPriceDisForMonthlyOrder||0;
            this.setState({mealData:mealObj, loading:false});
            this.getMealCreatedGradsByMonth(data.yearMonth);
            }else{
                this.setState({loading:false});

            }
        })
        .catch(
            (error) => {
                console.log('Get orderlist response', error)
            }
        )

    }
    getMealCreatedGradsByMonth(monthYear){
        this.setState({loading:true})
        //const mType= (this.state.mealType==MealTypes.LUNCH && !isRegularLunchOrderType())?MenuOrderTypes.ITEMIZE:this.state.mealType;
        get(URL_VERSION+'/mealCreatedGrades?itemType='+this.state.mealType+'&mealSchoolId=' + sessionStorage.getItem('SchoolId') +'&yearMonth='+monthYear+'&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('ordered meal grades', response);
            return response.json();
        }).then(data => {
            let grades=[];
            if((data||[]).length>0){
                grades=data;
            }

            this.setState({mealOrderedGrades:grades.join(',')});
            let finalArray=[];
            let editGrades=[]
            if(Object.keys(this.state.mealData||{}).length>0){
                console.log(this.state.mealData);
                editGrades=this.state.mealData.grades;//getGradeNamesByNumbers(this.state.mealData.grades).split(',');
            }
            //let respGradeNumberData=getGradeNamesByNumbers(data).split(',');

            finalArray= gradeList.map(item=>{
                let obj={name:item.label, value:item.value,checked:false,enabled:true};
                if(data.includes(item.value)){
                    obj.name=item.label;
                    obj.checked=true;
                    obj.enabled=false;
                }
                if(editGrades.includes(item.value)){
                    obj.enabled=true;
                }
                return obj;
            });
            this.setState({finalGradesArray:finalArray,loading:false});

            console.log('finalArray ',finalArray);
        })
        .catch(
            (error) => {
                this.setState({finalGradesArray:[],loading:false})
                console.log('Get orderlist response', error)
            }
        )
    }
     mealGradeSelectionChange(value,selected){
        let checkboxArray=this.state.finalGradesArray;
        let itm,index;
        checkboxArray.forEach((item,i)=>{
            if(value=='select_all'){
                if(item.enabled==true){
                    item.checked=selected;
                    itm=item;
                    index=i
                    return true;
                }  
            }
            else{
            if(item.value==value){
                item.checked=selected;
                itm=item;
                index=i
                return true;
            }
        }
        });

        checkboxArray[index]=itm;
        this.setState({finalGradesArray:checkboxArray});
    }

    loadMeals(data, grade, dateValue, cutOffObject={}) {
       const _cutOffObject={...cutOffObject, cutOffDateTime:moment(cutOffObject.cutOffDatetime).isValid()?moment(cutOffObject.cutOffDatetime):undefined }
        
        //alert(data)
        date = dateValue;
        console.log(JSON.stringify(data, null, 2))
        grades = grade;
        meals = data;
        if(this.state.mealType==MealTypes.LUNCH && !isRegularLunchOrderType()){
            const start=moment(date).startOf('week');
            const end=moment(date).endOf('week')
            let _alDates=this.state.alacarteDates;
            _alDates.start=start;
            _alDates.end=end;
            this.setState({fireRedirect: true, alacarteDates:_alDates, cutOffObj:_cutOffObject||{}});
        }else{
            this.setState({fireRedirect: true, cutOffObj:_cutOffObject||{}});
        }
    }
    loadBreakfast=(data,grade,dateValue)=>{
        date = dateValue;
        grades = grade;
        console.log(JSON.stringify(data, null, 2))
        breakfastData = data;
        this.setState({fireRedirect: true});
    }
    back() {
        this.setState({fireRedirect: false});
    }
    onCreatAlacarte=()=>{
        this.setState({modalIsOpen:true})
    }
    handleCreate=(cutOffObj)=> {
        let mealMenu={};
        this.setState({
            loading: true,
            modalIsOpen: false
        })
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let username = userInfo.username;
        mealMenu.loggedUser = username;
        let _grades = [];
        grades.map(grade => {
            //alert(grade);
            _grades.push(gradeNoToText(grade));
        })
        //alert(grades)
        mealMenu.reducedPriceStatus = meals.reducedPriceStatus;
        mealMenu.name=meals.name;
        mealMenu.gradesList = _grades;
        mealMenu.mealSchoolId = sessionStorage.getItem('SchoolId');
        mealMenu.yearMonth = "" + date.year + (('0' + (date.month)).slice(-2));
        mealMenu.mealMenus = [];
        if(cutOffObj.cutOffType =='W'){
            mealMenu.cutOffType=cutOffObj.cutOffType;
            mealMenu.weeklyOrderCutOffDay=cutOffObj.weeklyOrderCutOffDay;
            mealMenu.weeklyOrderCutOffTime=cutOffObj.weeklyOrderCutOffTime.format('HH:mm');
            mealMenu.allowOrderNDaysBefore=0
            mealMenu.cutOffDateTime = null;

        }else if(cutOffObj.cutOffType =='R'){
            mealMenu.cutOffType=cutOffObj.cutOffType;
            mealMenu.allowOrderNDaysBefore=cutOffObj.allowOrderNDaysBefore;
            mealMenu.weeklyOrderCutOffTime=cutOffObj.allowOrderNDaysTimeBefore.format('HH:mm');
            mealMenu.weeklyOrderCutOffDay='';
            mealMenu.cutOffDateTime = null;
        }else{
            let d1 = new Date(cutOffObj.cutOffDateTime);
            let d2 = new Date(cutOffObj.cutOffDateTime);
            mealMenu.orderDateExtensionStatus = cutOffObj.orderDateExtensionStatus;
            mealMenu.cutOffType='M';
            mealMenu.weeklyOrderCutOffDay='';          
            mealMenu.cutOffTzDateTime = moment(cutOffObj.cutOffDateTime).isValid()?moment(cutOffObj.cutOffDateTime).format('YYYY-MM-DD HH:mm:ss'):null;
            if (cutOffObj.autoReminderDate1) {
                mealMenu.autoReminderDate1 = formatDate(new Date(d1.setDate(d1.getDate() - 7)))
            }
            if (cutOffObj.autoReminderDate2) {
                mealMenu.autoReminderDate2 = formatDate(new Date(d2.setDate(d2.getDate() - 2)))
            }
        }
        mealMenu.isSideSelect= cutOffObj.isSideSelect;
        mealMenu.isExtraPreOrder=cutOffObj.isExtraPreOrder;
        mealMenu.extraEnableForCaterer=cutOffObj.extraEnableForCaterer;
        
        meals.mealMenuItems.forEach(mealItem => {
            let item = mealItem;
            delete item.id;
            delete item.end;
            if (item.type !== "HOLIDAY") {
                //alert(mealItem.type)
                item.mealImage = "";
                item.start = formatDate(new Date(item.start));
                mealMenu.mealMenus.push(item)
            } else {
                delete item.price;
                item.start = formatDate(new Date(item.start));
                mealMenu.mealMenus.push(item)
            }
        });
        if ((((meals||{}).extra||[]).length||0) > 0) {
            //alert(JSON.stringify(this.props.meals.extra,null,2))
            meals.extra.forEach(item => {
                let extraItem = item;
                delete extraItem.id;
                delete extraItem.start;
                delete extraItem.end;
                mealMenu.mealMenus.push(extraItem)
            })
        }
        if(this.menuId>0){
            mealMenu.schoolMealSummaryId=this.menuId;
        }
        let headers = {
            'Content-Type': 'application/json'
        }
        //const mType=(this.state.mealType==MealTypes.LUNCH && !isRegularLunchOrderType())?MenuOrderTypes.ITEMIZE:this.state.mealType;
        postWithHeadersResponse(URL_VERSION+'/schoolMealsCreate?itemType='+this.state.mealType+'&access_token=', JSON.stringify(mealMenu), headers).then((response) => {
            if (response.statusCode == 200) {
                this.setState({loading: false});
                _addNotification('Successfully Created Meal Menu.',this);

                setTimeout(() => {
                    this.context.router.history.push('/schoolAdmin/viewMenu')
                }, 3000);
                console.log('response', response);
            } else if (!response.ok) {
                throw Error(response.statusMessage);
            }
        }).catch(
            (error) => {
                this.setState({loading: false});
                _addNotificationError(error.message,this);
            }
        );
    }

    render() {
        gradeList=getSchoolGrades(0,false);
        return (
            <div className="container"> 
             <NotificationSystem ref="notificationSystem"/>
            {
                getAccessLevelByModule(modEnum.LMCU)|| getAccessLevelByModule(modEnum.BMCU)?
                <section className="full-width clearfix">
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="sectionTitle">
                    <h2 >                       
                        <span>{this.state.fireRedirect && 'Review'} Menu for: {sessionStorage.getItem('schoolYear')}</span>
                    
                        <MenuOptions menuOptionsList={getMenuOptions()} onOptionSelect={(type)=>{
                            this.setState({finalGradesArray:[], mealData:{}})
                                          this.setState({mealType:type},()=>{
                                            const frm=this.refs[`${type}-mealForm`];
                                            frm.refreshForm();
                                          })
                                    }} selectedOption={(this.state.mealType)} />               
                    </h2>        
                </div>
                
               {this.state.mealType===MealTypes.LUNCH?
                (<div>
                    {
                        !this.state.fireRedirect && <Fragment>
                    <MealForm type={MealTypes.LUNCH} ref={`${MealTypes.LUNCH}-mealForm`} 
                        title={this.state.isEdit ? 'Edit Lunch Menu' : 'Create Lunch Menu'} 
                        onChangeGradeSelection={this.mealGradeSelectionChange} loadMeals={this.loadMeals} schoolGrades={this.state.finalGradesArray} 
                    mealObject={this.state.mealData}
                    mealType= {'Lunch'}
                    onMealDateSelectionChange={this.getMealCreatedGradsByMonth}
                    onDiscountChanged={(amount)=>{
                        const _mealData=this.state.mealData;
                        _mealData.itemPriceDisForMonthlyOrder=amount;
                        this.setState({mealData:_mealData})
                    }}
                    onChangeMenuTitle={(e)=>{
                        const _mealData=this.state.mealData;
                        _mealData.name=e.target.value;
                        this.setState({mealData:_mealData})

                    }}
                    onDiscountSelectChange={(status)=>{
                        const _mealData=this.state.mealData;
                        _mealData.isDiscountApplyed=status;
                        if(!status){
                            _mealData.itemPriceDisForMonthlyOrder=0;
                        }
                        this.setState({mealData:_mealData})
                    }}
                     isEdit={this.state.isEdit ||false} />
                     </Fragment>}
                    {
                        this.state.fireRedirect && <Fragment>
                  
                    <FullCalendar type={MealTypes.LUNCH}  mealObject={this.state.mealData} 
                    meals={meals} schoolGrades={this.state.finalGradesArray} selectedGrades={grades} 
                    date={date} back={this.back} recId={this.menuId}/>
                   </Fragment>} 
                </div>)
                :
                this.state.mealType===MealTypes.SNACK?
                (<div>
                    {!this.state.fireRedirect &&
                    <MealForm type={MealTypes.SNACK} ref={`${MealTypes.SNACK}-mealForm`}
                    title={this.state.isEdit ? 'Edit Snack Menu' : 'Create Snack Menu'}
                    mealType= {'Snack'}
                    onChangeGradeSelection={this.mealGradeSelectionChange} loadMeals={this.loadMeals} schoolGrades={this.state.finalGradesArray} 
                    mealObject={this.state.mealData}
                    onDiscountChanged={(amount)=>{
                        const _mealData=this.state.mealData;
                        _mealData.itemPriceDisForMonthlyOrder=amount;
                        this.setState({mealData:_mealData})
                    }}
                    onDiscountSelectChange={(status)=>{
                        const _mealData=this.state.mealData;
                        _mealData.isDiscountApplyed=status;
                        if(!status){
                            _mealData.itemPriceDisForMonthlyOrder=0;
                        }
                        this.setState({mealData:_mealData})
                    }}
                    onChangeMenuTitle={(e)=>{
                        const _mealData=this.state.mealData;
                        _mealData.name=e.target.value;
                        this.setState({mealData:_mealData})

                    }}
                    onMealDateSelectionChange={this.getMealCreatedGradsByMonth}
                     isEdit={this.state.isEdit ||false} />
                     }
                    {
                        this.state.fireRedirect && <Fragment>
                        <FullCalendar type={MealTypes.SNACK}  mealObject={this.state.mealData} meals={meals} 
                        schoolGrades={this.state.finalGradesArray} selectedGrades={grades} 
                        date={date} back={this.back} recId={this.menuId} />
                   </Fragment> }
                </div>)

                :
                this.state.mealType===MealTypes.BREAKFAST?
                <Fragment><div>
                    {!this.state.fireRedirect && 
                    <MealForm type={MealTypes.BREAKFAST} ref={`${MealTypes.BREAKFAST}-mealForm`}
                    mealType= {MealTypes.BREAKFAST}
                    title={this.state.isEdit ? 'Edit Breakfast Menu' : 'Create Breakfast Menu'}
                    onChangeGradeSelection={this.mealGradeSelectionChange} loadMeals={this.loadMeals} schoolGrades={this.state.finalGradesArray} 
                    mealObject={this.state.mealData}
                    onDiscountChanged={(amount)=>{
                        const _mealData=this.state.mealData;
                        _mealData.itemPriceDisForMonthlyOrder=amount;
                        this.setState({mealData:_mealData})
                    }}
                    onDiscountSelectChange={(status)=>{
                        const _mealData=this.state.mealData;
                        _mealData.isDiscountApplyed=status;
                        if(!status){
                            _mealData.itemPriceDisForMonthlyOrder=0;
                        }
                        this.setState({mealData:_mealData})
                    }}
                    onChangeMenuTitle={(e)=>{
                        const _mealData=this.state.mealData;
                        _mealData.name=e.target.value;
                        this.setState({mealData:_mealData})

                    }}
                    onMealDateSelectionChange={this.getMealCreatedGradsByMonth}
                     isEdit={this.state.isEdit ||false} />
                     }
                    {
                        this.state.fireRedirect &&
                        <FullCalendar type={MealTypes.BREAKFAST}  mealObject={this.state.mealData} 
                        meals={meals} schoolGrades={this.state.finalGradesArray} selectedGrades={grades} 
                        date={date} back={this.back} recId={this.menuId} />
                    }
                </div>
               </Fragment>
                :
                this.state.mealType==MealTypes.DINNER?
                (<div>
                    {!this.state.fireRedirect &&
                    <MealForm type={MealTypes.DINNER} ref={`${MealTypes.DINNER}-mealForm`}
                    title={this.state.isEdit ? 'Edit Dinner Menu' : 'Create Dinner Menu'}
                    mealType= {'Dinner'}
                    onChangeGradeSelection={this.mealGradeSelectionChange} loadMeals={this.loadMeals} schoolGrades={this.state.finalGradesArray} 
                    mealObject={this.state.mealData}
                    onDiscountChanged={(amount)=>{
                        const _mealData=this.state.mealData;
                        _mealData.itemPriceDisForMonthlyOrder=amount;
                        this.setState({mealData:_mealData})
                    }}
                    onDiscountSelectChange={(status)=>{
                        const _mealData=this.state.mealData;
                        _mealData.isDiscountApplyed=status;
                        if(!status){
                            _mealData.itemPriceDisForMonthlyOrder=0;
                        }
                        this.setState({mealData:_mealData})
                    }}
                    onChangeMenuTitle={(e)=>{
                        const _mealData=this.state.mealData;
                        _mealData.name=e.target.value;
                        this.setState({mealData:_mealData})

                    }}
                    onMealDateSelectionChange={this.getMealCreatedGradsByMonth}
                     isEdit={this.state.isEdit ||false} />
                     }
                    {
                        this.state.fireRedirect &&
                        <FullCalendar type={MealTypes.DINNER}  mealObject={this.state.mealData} meals={meals} 
                        schoolGrades={this.state.finalGradesArray} selectedGrades={grades} 
                        date={date} back={this.back} recId={this.menuId} />
                    }
                </div>)
                :null
               }
                <br/>
                <br/>
                </section>:
                <section className="full-width clearfix">

                </section>
            } 
            <Modal
                        isOpen={this.state.modalIsOpen}
                        style={modalStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                    >
                        <button type="button" className="pull-right" data-dismiss="modal" onClick={() => {
                            this.setState({modalIsOpen: false})
                        }}>&times;</button>
                        <div className="row">
                            <h3 style={{color: '#0000b2'}} className="text-center">Cut-off Date</h3>
                            <form>
                                <div className="col-md-10 col-md-offset-1">
                                    <CutoffDays mealObj={{...this.state.cutOffObj, 
                            cutOffDatetime: moment(this.state.cutOffObj.cutOffDateTime).isValid()?moment(this.state.cutOffObj.cutOffDateTime):undefined }} {...this} isWeekly={isWeekMenu(this.state.mealType)} onCutoffDateSubmit={(cutOffObj)=>{
                                        this.handleCreate(cutOffObj);
                                    }} />                                     
                                </div>                                
                            </form>
                        </div>
            </Modal>
           
            </div>

        );
    }
}
mealCreate.contextTypes = {
    router: PropTypes.object.isRequired
}

export default mealCreate;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/mealCreate.js